import React, { Component } from 'react';
import Head from 'next/head'
import { Header, Footer, Fixture, TeamStanding, PlayerStat, GoalieStat, TeamStat, Link, Dropdown, PageWrapper } from '../components'
import { fetchTeam } from '../api/teams'
import { fetchClub } from '../api/clubs'
import { fetchResults, fetchFutureFixtures } from '../api/fixtures'
import { fetchEntry } from '../api/division-entries'
import { fetchDivision } from '../api/divisions'
import { fetchStandings, fetchForClub } from '../api/division-entries'
import { fetchStats, fetchGoalieStats } from '../api/roles'
import { fetchCompetitions } from '../api/competitions'
import { format } from 'date-fns'

class TeamPage extends Component {

  static generateTeamStats(results, standings, team) {
    let cleanSheets = 0
    let forfeitsAgainst = 0
    let forfeitsFor = 0
    let penalty_seconds;
    const bestResult = {
      goalsFor: 0,
      goalsAgainst: 0,
      goalDifference: 0
    }
    const teamStat = standings.data.find( (s) => s.team_id == team.id);
    results.data.forEach(function(r) {
      if (r.status != 'not_started') {
        const isHome = r.home_entry.team_id == team.id;
        const goals_for = isHome ? r.home_entry.result.score : r.away_entry.result.score
        const goals_against = isHome ? r.away_entry.result.score : r.home_entry.result.score
        const goal_diff = goals_for - goals_against
        const resultType = isHome ? r.home_entry.result.type : r.away_entry.result.type
        if (goal_diff > bestResult.goalDifference || goal_diff == bestResult.goalDifference && goals_for > bestResult.goalsFor) {
          bestResult.goalDifference = goal_diff
          bestResult.goalsAgainst = goals_against
          bestResult.goalsFor = goals_for
        }

        if (resultType == 'forfeit/against') {
          forfeitsAgainst++
        }

        if (resultType == 'forfeit/for') {
          forfeitsFor++
        }

        if (goals_against == 0) {
            cleanSheets++;
        }
      }
    })
    return {
      bestResult: bestResult,
      winPercentage: teamStat.stats.played > 0 ? (teamStat.stats.won / teamStat.stats.played * 100).toFixed(2) : 0,
      goalAverage: teamStat.stats.played > 0 ? (teamStat.stats.goals_for / teamStat.stats.played).toFixed(2) : 0,
      cleanSheets: cleanSheets,
      forfeitsAgainst: forfeitsAgainst,
      forfeitsFor: forfeitsFor,
      goalsAgainstAverage: teamStat.stats.played > 0 ? (teamStat.stats.goals_against / teamStat.stats.played).toFixed(2) : 0,
      penaltySecondsAverage: teamStat.stats.played > 0 ? ((teamStat.stats.penalty_seconds / teamStat.stats.played)/60).toFixed(2) : 0
    }
  }

  static async getInitialProps({req, query, props}) {
    const team = await fetchTeam(query.team)
    const clubPromise = fetchClub(team.club_id)
    const results = await fetchResults({'team_id': query.divisionEntry})
    const fixtures = await fetchFutureFixtures({'team_id': query.divisionEntry})
    const divisionEntry = await fetchEntry(query.divisionEntry)
    const division = await fetchDivision(divisionEntry.division_id)
    const standings = await fetchStandings(division.id)
    const playerStats = await fetchStats({'division_id': division.id})
    const goalieStats = await fetchGoalieStats({'division_id': division.id})
    const divisionEntries = await fetchForClub(team.club_id)

    goalieStats.data.forEach(function(result) {
        result.stats.play_time = Math.round((result.stats.seconds_played / result.stats.all_game_seconds) * 100, 2)
        if (result.stats.adjusted_all_game_seconds > 0) {
          result.stats.adjusted_play_time = Math.round((result.stats.adjusted_seconds / result.stats.adjusted_all_game_seconds) * 100, 2)
        } else {
          result.stats.adjusted_play_time = 0;
        }
    })

    return {
      organisationId: props.organisationId,
      team: team,
      club: await clubPromise,
      results: results,
      division: division,
      standings: standings,
      fixtures: fixtures,
      stats: await playerStats.data.filter((s) => s.team_id == team.id),
      goalieStats: goalieStats.data.filter((s) => s.team_id == team.id),
      teamStats: TeamPage.generateTeamStats(results, standings, team),
      entries: divisionEntries.data.filter(function(e) {
        return e.name == team.name
      }).map(function(e) {
        return {
          id: e.division.id,
          name: e.division.name,
          entry_id: e.id,
          team_id: e.team_id
        }
      }),
      currentEntry: divisionEntries.data.find(function(e) {
        return e.id == divisionEntry.id
      })
    }
  }

  render() {
    const { currentEntry, team, results, fixtures, club, division, standings, stats, goalieStats, teamStats, activeCompetition, entries, organisationId, organisation, pages } = this.props
    let currentDate, lastDate
    let imageSrc="https://brha.co/static/photo.png"
    if (club.logo_image && club.logo_image.file) {
      imageSrc = club.logo_image.file.uri
    }
    return (<div className={`u-grid u-grid--team u-grid-${organisationId}`}>
        <Head>
          <title>{ `${organisation.name} | Team | ${team.name } | ${division.name}`}</title>
          <meta property="og:title" content={`BRHA | Team | ${team.name } | ${division.name}`} />
          <meta property="og:description" content={`Stats, fixtures, results for ${team.name }`} />
          <meta property="og:image" content={imageSrc} />
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <h1>{`${team.name}`}<span className="u-aux">{` | ${division.name}`}</span></h1>
            <div className="u-grid__team_details">
              <div className="u-grid__logo">{club.logo_image && club.logo_image.file && <img className="o-team__logo--large" src={club.logo_image.file.uri} />}</div>

              <div className="u-grid__stats">
                <TeamStat title={`Best Result`} value={`${teamStats.bestResult.goalsFor} - ${teamStats.bestResult.goalsAgainst}`} />
                <TeamStat title={`Win Percentage`} value={`${teamStats.winPercentage}%`} />
                <TeamStat title={`Clean Sheets`} value={`${teamStats.cleanSheets}`} />
                <TeamStat title={`Goal Average`} value={`${teamStats.goalAverage}`} />
                <TeamStat title={`Goal Against Average`} value={`${teamStats.goalsAgainstAverage}`} />
                <TeamStat title={`Penalty Min Average`} value={`${teamStats.penaltySecondsAverage}`} />
              </div>
              <div className="u-grid__divisions">
                <Dropdown activeId={currentEntry.division.id} options={entries} urlFormatter={function(o) { return '/team?team=' + o.team_id + '&divisionEntry=' + o.entry_id }} title="SeasonSelector"></Dropdown>
              </div>
            </div>
        </div>

        <div className="u-grid__standings">
          <h1>Team Standings</h1>
          {standings.data.length > 0 &&
            <table>
              <thead>
                <tr>
                  <th>{'Team'}</th>
                  <th className="u-center">
                    <span className="u-show-mobile-landscape">{'P'}</span>
                    <span className="u-hide-mobile-landscape">{'Played'}</span>
                  </th>
                  <th className="u-center u-show-mobile-landscape">{'W'}</th>
                  <th className="u-center u-show-mobile-landscape">{'D'}</th>
                  <th className="u-center u-show-mobile-landscape">{'L'}</th>
                  <th className="u-center u-show-tablet-portrait">{'GF'}</th>
                  <th className="u-center u-show-tablet-portrait">{'GA'}</th>
                  <th className="u-center u-show-mobile-landscape">{'GD'}</th>
                  <th className="u-center">
                    <span className="u-show-mobile-landscape">{'Pts'}</span>
                    <span className="u-hide-mobile-landscape">{'Points'}</span></th>
                </tr>
              </thead>
              <tbody>
                {standings.data.map(s =>
                  <TeamStanding key={s.id} name={s.name} teamId={s.team_id} divisionEntryId={s.id} stats={s.stats} />
                )}
              </tbody>
            </table>
          }
          <h1>{'Player Stats'}</h1>

          {stats && stats.length > 0 &&
            <table className="table--responsive table--player-stats">
              <thead>
                <tr>
                  <th>{'Player'}</th>
                  <th className="u-center">
                    {'Played'}
                  </th>
                  <th className="u-center">{'Goals'}</th>
                  <th className="u-center u-show-mobile-landscape">{'Assists'}</th>
                  <th className="u-center u-show-mobile-landscape">{'PIM'}</th>
                  <th className="u-center">{'Pts'}</th>
                </tr>
              </thead>
              <tbody>
                {stats.map(s =>
                  <PlayerStat key={s.id} member={s.name} stats={s.stats} under_18={s.under_18} />
                )}
              </tbody>
            </table>
          }

          <h1>{'Goalie Stats'}</h1>
          {goalieStats && goalieStats.length > 0 &&
            <table className="table--responsive table--player-stats">
              <thead>
                <tr>
                  <th>{'Player'}</th>
                  <th></th>
                  <th className="u-center">
                    {'Played'}
                  </th>
                  <th className="u-center">{'Goals Against'}</th>
                  <th className="u-center">{'Goals Against Avg'}</th>
                  <th className="u-center">{'Play Time'}</th>

                </tr>
              </thead>
              <tbody>
                {goalieStats.map(s =>
                  <GoalieStat key={s.id} member={s.name} stats={s.stats} under_18={s.under_18} />
                )}
              </tbody>
            </table>
          }
        </div>
        <div className="u-grid__results">
          <h1>Next Fixtures</h1>
          {fixtures.data.map(result =>
            <div>
              {currentDate = format(result.start_time, 'Do MMMM YYYY'), ''}
              {currentDate != lastDate && <h2 className="u-aux">{format(result.start_time, 'Do MMMM YYYY')}</h2>}
              <Fixture key={result.id} type="full" fixture={result} showDivision={false} />
              {lastDate = currentDate, ''}

            </div>
          )}
          <h1>Results</h1>
          {results.data.map(result =>
            <div key={`results-${result.id}`}>
              {currentDate = format(result.start_time, 'Do MMMM YYYY'), ''}
              {currentDate != lastDate && <h2 className="u-aux">{format(result.start_time, 'Do MMMM YYYY')}</h2>}
              <Fixture key={result.id} type="full" fixture={result} showDivision={false} />
              {lastDate = currentDate, ''}

            </div>
          )}
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }
}

export default PageWrapper(TeamPage)
